import React, { useState, useEffect } from "react";
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import video from '../../assets/videos/video-5-1.mp4';
// import Carousel from 'react-bootstrap/Carousel';
import { Carousel } from 'antd';
import VideoModal2 from '../../components/videomodalthird/video-modal-third';
import { Link } from "react-router-dom";
import './howitworks.css';

const HowItWorks = () => {

  const [activeView, setActiveView] = useState("notification");

  const setView = (value) => {
    setActiveView(value);
  }
  const [patientType, setPatientType] = useState("patient")

  const checkPlan = (value) => {
    setPatientType(value);
  }

  const [planTime, setPlanTime] = useState("one")

  const checkTime = (value) => {
    setPlanTime(value);
  }

  const [playVideo2, setPlayVideo2] = useState(false);
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  const openModal2 = () => {
    setPlayVideo2(true);
    let open2 = document.getElementById("modalOpen")
    open2.classList.add("mystyle");
  }
  return (
    <>
      <div className="header2">
        <section className="hp-section--hero js-section--hero pl-0 pt-0 pr-0">
          <Header></Header>
          <VideoModal2 playVideo2={playVideo2} setPlayVideo2={setPlayVideo2} />
          <div className="hp-hero-txt-mod text_responsive_home_2">
            <h1 className="hero-h">Your <span style={{ color: "#008CD3", fontWeight: "600" }}>medication,</span><br></br> made easy</h1>
            <p className="hero-p">
              No more sorting meds, waiting in line, or<br></br> chasing down refills.
            </p>
            <button className="btn btn-lg pulsingButton" type="button" onClick={openModal2}>
              <i className="fa fa-play ml-2"></i> Watch Video
            </button>
          </div>
          <div className="hw-hero-art-mod" style={{ bottom: "initial" }}>
            <video style={{ width: "100%" }} className="js-plyrVideo plyr--setup img-fluid" autoPlay muted>
              <source src={video} type="video/mp4" />
            </video>  
            {/* <Carousel dotPosition={'bottom'}>
              <div className="image_overlay">
                <img className="howitworks_image_height" src={sliderImg} style={{ width: "100%" }}></img>
              </div>
              <div className="image_overlay">
                <img className="howitworks_image_height" src={sliderImg1} style={{ width: "100%" }}></img>
              </div>
              <div className="image_overlay">
                <img className="howitworks_image_height" src={sliderImg2} style={{ width: "100%" }}></img>
              </div>
            </Carousel> */}
          </div>
        </section>
      </div>
      <div className="container_setting hero_circularMenu">
        <div className="row">
          <div className="col-md-6 col-lg-6 phone-holder col-sm-12 mb-5">
            <div className="mobile_flex_section">
              <div className="section_mobile_side display_none_mobile">
                <img style={{ width: "100%", height: "100%" }} src={require("../../assets/images/mobilecover.png")}></img>
              </div>
              <div className="display_none_mobile section_mobile_side_img">
                {
                  activeView === "calender" && (
                    <img style={{ width: "100%", height: "100%" }} src={require("../../assets/images/Upload-Prescription.png")}></img>
                  )
                }
                {
                  activeView === "notification" && (
                    <img style={{ width: "100%", height: "100%" }} src={require("../../assets/images/Signup.png")}></img>
                  )
                }
                {
                  activeView === "network" && (
                    <img style={{ width: "100%", height: "100%" }} src={require("../../assets/images/Home-h.png")}></img>
                  )
                }
                {
                  activeView === "wishlist" && (
                    <img style={{ width: "100%", height: "100%" }} src={require("../../assets/images/oredrplace.png")}></img>
                  )
                }
                {
                  activeView === "sidemenu" && (
                    <img style={{ width: "100%", height: "100%" }} src={require("../../assets/images/medical-schedule.png")}></img>
                  )
                }
              </div>
              <div className="rounded-circle main_border_circle">
                <div className="position-absolute first_icon_how">
                  {
                    activeView === "notification" ? (
                      <svg onClick={() => { setView("notification") }} xmlns="http://www.w3.org/2000/svg" width={56} height={56} viewBox="0 0 56 56" style={{ boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 45px -10px", borderRadius: "100px" }}>
                        <g id="Notification" transform="translate(-13786 -1189.237)">
                          <g id="Group_24024" data-name="Group 24024" transform="translate(13786 1189.237)">
                            <circle id="Elipsa_2_kopia_5" data-name="Elipsa 2 kopia 5" cx={28} cy={28} r={28} fill="#fff" />
                            <ellipse id="Elipsa_2_kopia_7" data-name="Elipsa 2 kopia 7" cx="25.198" cy="25.58" rx="25.198" ry="25.58" transform="translate(3.047 2.049)" fill="#0081ce" />
                          </g>
                          <g id="user" transform="translate(13802 1202.898)">
                            <path id="Path_2987" data-name="Path 2987" d="M93.819,13.574a6.567,6.567,0,0,0,4.8-1.988,6.568,6.568,0,0,0,1.988-4.8,6.568,6.568,0,0,0-1.988-4.8,6.785,6.785,0,0,0-9.6,0,6.567,6.567,0,0,0-1.988,4.8,6.567,6.567,0,0,0,1.988,4.8A6.569,6.569,0,0,0,93.819,13.574ZM90.891,8.191c1.012-1.012,1.291,2.767,2.722,2.767s2.824-4,3.837-2.99.715-2.611.715-1.181-.683-2.376-1.7-1.363-1.22-.848-2.651-.848-2.5.655-3.508-.357-.43,3.9-.43,2.472S89.878,9.2,90.891,8.191Zm-.268-.714" transform="translate(-82.242 0)" fill="#fff" />
                            <path id="Path_2988" data-name="Path 2988" d="M23.452,255.373a16.761,16.761,0,0,0-.228-1.78,14.027,14.027,0,0,0-.438-1.79,8.844,8.844,0,0,0-.736-1.67,6.292,6.292,0,0,0-1.11-1.446,4.893,4.893,0,0,0-1.594-1,5.509,5.509,0,0,0-2.035-.368,2.065,2.065,0,0,0-1.1.468c-.331.216-.717.465-1.149.741a6.585,6.585,0,0,1-1.487.655,5.773,5.773,0,0,1-3.637,0,6.565,6.565,0,0,1-1.486-.655c-.428-.273-.815-.523-1.15-.741a2.064,2.064,0,0,0-1.1-.468,5.5,5.5,0,0,0-2.035.369,4.889,4.889,0,0,0-1.594,1,6.3,6.3,0,0,0-1.109,1.446,8.861,8.861,0,0,0-.736,1.67,14.058,14.058,0,0,0-.438,1.79,16.647,16.647,0,0,0-.228,1.781c-.037.538-.056,1.1-.056,1.664a4.679,4.679,0,0,0,1.39,3.54,5,5,0,0,0,3.581,1.306H18.539a5,5,0,0,0,3.581-1.306,4.677,4.677,0,0,0,1.39-3.54c0-.568-.019-1.128-.057-1.664Zm-2.471,4.008a3.368,3.368,0,0,1-2.442.851H4.971a3.368,3.368,0,0,1-2.442-.851,3.055,3.055,0,0,1-.877-2.344c0-.528.017-1.049.052-1.55a15.019,15.019,0,0,1,.206-1.6,12.4,12.4,0,0,1,.385-1.578,7.215,7.215,0,0,1,.6-1.358,20.9,20.9,0,0,0-1.436,2.364c.283-.271-1.09,4.916-.67,4.75.389-.154,1.631,1.919,2.106,1.906.058.031.884.5,1.051.609.339.221.974-.2,1.406.079.488.311.546-.039,1.3.2.767.248-2.835-.8,5.106-.282s8.783-.533,9.55-.78c.751-.243.327-3.374.816-3.686.443-.283-.218-.517.122-.739.167-.109-.37-.42-.312-.451.475.013.017-2.77.406-2.616A24.138,24.138,0,0,0,19.8,249.88a4.653,4.653,0,0,1,.815,1.069,7.189,7.189,0,0,1,.6,1.357,12.374,12.374,0,0,1,.385,1.578,15.145,15.145,0,0,1,.206,1.6h0c.035.5-.592,1.092-.592,1.621,0,1.015.358,1.71-.233,2.272Zm0,0" transform="translate(0 -233.705)" fill="#fff" />
                          </g>
                        </g>
                      </svg>
                    ) : (
                        <svg onClick={() => { setView("notification") }} xmlns="http://www.w3.org/2000/svg" width={56} height={56} viewBox="0 0 56 56">
                          <g id="Notification" transform="translate(-13786 -1189.237)">
                            <g id="Group_24024" data-name="Group 24024" transform="translate(13786 1189.237)">
                              <circle id="Elipsa_2_kopia_5" data-name="Elipsa 2 kopia 5" cx={28} cy={28} r={28} fill="#fff" />
                              <ellipse id="Elipsa_2_kopia_7" data-name="Elipsa 2 kopia 7" cx="25.198" cy="25.58" rx="25.198" ry="25.58" transform="translate(3.047 2.049)" fill="#e7e7e7" />
                            </g>
                            <g id="user" transform="translate(13802 1202.898)">
                              <path id="Path_2987" data-name="Path 2987" d="M93.819,13.574a6.567,6.567,0,0,0,4.8-1.988,6.568,6.568,0,0,0,1.988-4.8,6.568,6.568,0,0,0-1.988-4.8,6.785,6.785,0,0,0-9.6,0,6.567,6.567,0,0,0-1.988,4.8,6.567,6.567,0,0,0,1.988,4.8A6.569,6.569,0,0,0,93.819,13.574ZM90.891,8.191c1.012-1.012,1.291,2.767,2.722,2.767s2.824-4,3.837-2.99.715-2.611.715-1.181-.683-2.376-1.7-1.363-1.22-.848-2.651-.848-2.5.655-3.508-.357-.43,3.9-.43,2.472S89.878,9.2,90.891,8.191Zm-.268-.714" transform="translate(-82.242 0)" fill="#fff" />
                              <path id="Path_2988" data-name="Path 2988" d="M23.452,255.373a16.761,16.761,0,0,0-.228-1.78,14.027,14.027,0,0,0-.438-1.79,8.844,8.844,0,0,0-.736-1.67,6.292,6.292,0,0,0-1.11-1.446,4.893,4.893,0,0,0-1.594-1,5.509,5.509,0,0,0-2.035-.368,2.065,2.065,0,0,0-1.1.468c-.331.216-.717.465-1.149.741a6.585,6.585,0,0,1-1.487.655,5.773,5.773,0,0,1-3.637,0,6.565,6.565,0,0,1-1.486-.655c-.428-.273-.815-.523-1.15-.741a2.064,2.064,0,0,0-1.1-.468,5.5,5.5,0,0,0-2.035.369,4.889,4.889,0,0,0-1.594,1,6.3,6.3,0,0,0-1.109,1.446,8.861,8.861,0,0,0-.736,1.67,14.058,14.058,0,0,0-.438,1.79,16.647,16.647,0,0,0-.228,1.781c-.037.538-.056,1.1-.056,1.664a4.679,4.679,0,0,0,1.39,3.54,5,5,0,0,0,3.581,1.306H18.539a5,5,0,0,0,3.581-1.306,4.677,4.677,0,0,0,1.39-3.54c0-.568-.019-1.128-.057-1.664Zm-2.471,4.008a3.368,3.368,0,0,1-2.442.851H4.971a3.368,3.368,0,0,1-2.442-.851,3.055,3.055,0,0,1-.877-2.344c0-.528.017-1.049.052-1.55a15.019,15.019,0,0,1,.206-1.6,12.4,12.4,0,0,1,.385-1.578,7.215,7.215,0,0,1,.6-1.358,20.9,20.9,0,0,0-1.436,2.364c.283-.271-1.09,4.916-.67,4.75.389-.154,1.631,1.919,2.106,1.906.058.031.884.5,1.051.609.339.221.974-.2,1.406.079.488.311.546-.039,1.3.2.767.248-2.835-.8,5.106-.282s8.783-.533,9.55-.78c.751-.243.327-3.374.816-3.686.443-.283-.218-.517.122-.739.167-.109-.37-.42-.312-.451.475.013.017-2.77.406-2.616A24.138,24.138,0,0,0,19.8,249.88a4.653,4.653,0,0,1,.815,1.069,7.189,7.189,0,0,1,.6,1.357,12.374,12.374,0,0,1,.385,1.578,15.145,15.145,0,0,1,.206,1.6h0c.035.5-.592,1.092-.592,1.621,0,1.015.358,1.71-.233,2.272Zm0,0" transform="translate(0 -233.705)" fill="#fff" />
                            </g>
                          </g>
                        </svg>
                      )
                  }
                </div>
                <div className="position-absolute second_icon_how">
                  {
                    activeView === "network" ? (
                      <svg onClick={() => { setView("network") }} xmlns="http://www.w3.org/2000/svg" width={56} height={56} viewBox="0 0 56 56" style={{ boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 45px -10px", borderRadius: "100px" }}>
                        <g id="Notification" transform="translate(-13786 -1189.237)">
                          <g id="Group_24024" data-name="Group 24024" transform="translate(13786 1189.237)">
                            <circle id="Elipsa_2_kopia_5" data-name="Elipsa 2 kopia 5" cx={28} cy={28} r={28} fill="#fff" />
                            <ellipse id="Elipsa_2_kopia_7" data-name="Elipsa 2 kopia 7" cx="25.198" cy="25.58" rx="25.198" ry="25.58" transform="translate(3.047 2.049)" fill="#0081ce" />
                          </g>
                          <path id="iconfinder_home_126572_1_" data-name="iconfinder_home_126572 (1)" d="M27.21,12.328,24.656,9.776V3.522A1.766,1.766,0,0,0,22.9,1.761H21.134a1.766,1.766,0,0,0-1.761,1.761V4.5L15.85.977A2.47,2.47,0,0,0,14.089,0a2.47,2.47,0,0,0-1.761.977L.969,12.328A2.438,2.438,0,0,0,0,14.089,1.732,1.732,0,0,0,1.761,15.85H3.522V26.417a1.766,1.766,0,0,0,1.761,1.761h5.283V19.373a1.766,1.766,0,0,1,1.761-1.761H15.85a1.766,1.766,0,0,1,1.761,1.761v8.806H22.9a1.766,1.766,0,0,0,1.761-1.761V15.85h1.761a1.732,1.732,0,0,0,1.761-1.761A2.438,2.438,0,0,0,27.21,12.328Z" transform="translate(13800 1202.899)" fill="#fff" />
                        </g>
                      </svg>
                    ) : (
                        <svg onClick={() => { setView("network") }} xmlns="http://www.w3.org/2000/svg" width={56} height={56} viewBox="0 0 56 56">
                          <g id="Notification" transform="translate(-13786 -1189.237)">
                            <g id="Group_24024" data-name="Group 24024" transform="translate(13786 1189.237)">
                              <circle id="Elipsa_2_kopia_5" data-name="Elipsa 2 kopia 5" cx={28} cy={28} r={28} fill="#fff" />
                              <ellipse id="Elipsa_2_kopia_7" data-name="Elipsa 2 kopia 7" cx="25.198" cy="25.58" rx="25.198" ry="25.58" transform="translate(3.047 2.049)" fill="#e7e7e7" />
                            </g>
                            <path id="iconfinder_home_126572_1_" data-name="iconfinder_home_126572 (1)" d="M27.21,12.328,24.656,9.776V3.522A1.766,1.766,0,0,0,22.9,1.761H21.134a1.766,1.766,0,0,0-1.761,1.761V4.5L15.85.977A2.47,2.47,0,0,0,14.089,0a2.47,2.47,0,0,0-1.761.977L.969,12.328A2.438,2.438,0,0,0,0,14.089,1.732,1.732,0,0,0,1.761,15.85H3.522V26.417a1.766,1.766,0,0,0,1.761,1.761h5.283V19.373a1.766,1.766,0,0,1,1.761-1.761H15.85a1.766,1.766,0,0,1,1.761,1.761v8.806H22.9a1.766,1.766,0,0,0,1.761-1.761V15.85h1.761a1.732,1.732,0,0,0,1.761-1.761A2.438,2.438,0,0,0,27.21,12.328Z" transform="translate(13800 1202.899)" fill="#fff" />
                          </g>
                        </svg>
                      )
                  }
                </div>
                <div className="position-absolute third_icon_how">
                  {
                    activeView === "calender" ? (
                      <svg onClick={() => { setView("calender") }}
                        xmlns="http://www.w3.org/2000/svg"
                        width={56}
                        height={56}
                        viewBox="0 0 56 56"
                        style={{ boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 45px -10px", borderRadius: "100px" }}>
                        <g id="Upload" transform="translate(0.006 0.138)">
                          <circle
                            id="Elipsa_2_kopia_4"
                            data-name="Elipsa 2 kopia 4"
                            cx={28}
                            cy={28}
                            r={28}
                            transform="translate(-0.006 -0.138)"
                            fill="#fff"
                          />
                          <path
                            id="Elipsa_2_kopia_8"
                            data-name="Elipsa 2 kopia 8"
                            d="M25.2,0A25.437,25.437,0,0,1,50.4,25.667,25.437,25.437,0,0,1,25.2,51.333,25.437,25.437,0,0,1,0,25.667,25.437,25.437,0,0,1,25.2,0Z"
                            transform="translate(2.794 1.728)"
                            fill="#0081CE"
                          />
                          <g
                            id="Icon_ionic-ios-camera"
                            data-name="Icon ionic-ios-camera"
                            transform="translate(15.861 18.285)"
                          >
                            <path
                              id="Path_3277"
                              data-name="Path 3277"
                              d="M21.5,19.066a3.773,3.773,0,1,1-3.773-3.773A3.773,3.773,0,0,1,21.5,19.066Z"
                              transform="translate(-5.13 -8.37)"
                              fill="#fff"
                            />
                            <path
                              id="Path_3278"
                              data-name="Path 3278"
                              d="M27.7,11.025H24.122a1.065,1.065,0,0,1-.788-.354c-1.864-2.087-2.566-2.8-3.327-2.8H14.4c-.768,0-1.523.709-3.393,2.8a1.045,1.045,0,0,1-.781.348H9.953V10.5a.527.527,0,0,0-.525-.525H7.722A.527.527,0,0,0,7.2,10.5v.525H6.7A2.128,2.128,0,0,0,4.5,13.04V24.59a2.272,2.272,0,0,0,2.2,2.185h21a2.1,2.1,0,0,0,2-2.185V13.04A1.956,1.956,0,0,0,27.7,11.025ZM17.362,24.176A5.611,5.611,0,1,1,22.7,18.834,5.616,5.616,0,0,1,17.362,24.176ZM23.4,14.831a.853.853,0,1,1,.853-.853A.851.851,0,0,1,23.4,14.831Z"
                              transform="translate(-4.5 -7.875)"
                              fill="#fff"
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                        <svg onClick={() => { setView("calender") }}
                          xmlns="http://www.w3.org/2000/svg"
                          width={56}
                          height={56}
                          viewBox="0 0 56 56"
                        >
                          <g id="Upload" transform="translate(0.006 0.138)">
                            <circle
                              id="Elipsa_2_kopia_4"
                              data-name="Elipsa 2 kopia 4"
                              cx={28}
                              cy={28}
                              r={28}
                              transform="translate(-0.006 -0.138)"
                              fill="#fff"
                            />
                            <path
                              id="Elipsa_2_kopia_8"
                              data-name="Elipsa 2 kopia 8"
                              d="M25.2,0A25.437,25.437,0,0,1,50.4,25.667,25.437,25.437,0,0,1,25.2,51.333,25.437,25.437,0,0,1,0,25.667,25.437,25.437,0,0,1,25.2,0Z"
                              transform="translate(2.794 1.728)"
                              fill="#e7e7e7"
                            />
                            <g
                              id="Icon_ionic-ios-camera"
                              data-name="Icon ionic-ios-camera"
                              transform="translate(15.861 18.285)"
                            >
                              <path
                                id="Path_3277"
                                data-name="Path 3277"
                                d="M21.5,19.066a3.773,3.773,0,1,1-3.773-3.773A3.773,3.773,0,0,1,21.5,19.066Z"
                                transform="translate(-5.13 -8.37)"
                                fill="#fff"
                              />
                              <path
                                id="Path_3278"
                                data-name="Path 3278"
                                d="M27.7,11.025H24.122a1.065,1.065,0,0,1-.788-.354c-1.864-2.087-2.566-2.8-3.327-2.8H14.4c-.768,0-1.523.709-3.393,2.8a1.045,1.045,0,0,1-.781.348H9.953V10.5a.527.527,0,0,0-.525-.525H7.722A.527.527,0,0,0,7.2,10.5v.525H6.7A2.128,2.128,0,0,0,4.5,13.04V24.59a2.272,2.272,0,0,0,2.2,2.185h21a2.1,2.1,0,0,0,2-2.185V13.04A1.956,1.956,0,0,0,27.7,11.025ZM17.362,24.176A5.611,5.611,0,1,1,22.7,18.834,5.616,5.616,0,0,1,17.362,24.176ZM23.4,14.831a.853.853,0,1,1,.853-.853A.851.851,0,0,1,23.4,14.831Z"
                                transform="translate(-4.5 -7.875)"
                                fill="#fff"
                              />
                            </g>
                          </g>
                        </svg>
                      )
                  }
                </div>
                <div className="position-absolute fourth_icon_how">
                  {
                    activeView === "wishlist" ? (
                      <svg onClick={() => { setView("wishlist") }}
                        xmlns="http://www.w3.org/2000/svg"
                        width={56}
                        height={56}
                        viewBox="0 0 56 56"
                        style={{ boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 45px -10px", borderRadius: "100px" }}
                      >
                        <g id="Grupa_1" data-name="Grupa 1" transform="translate(0.006 -0.161)">
                          <circle
                            id="Elipsa_2_kopia"
                            data-name="Elipsa 2 kopia"
                            cx={28}
                            cy={28}
                            r={28}
                            transform="translate(-0.006 0.161)"
                            fill="#fff"
                          />
                          <ellipse
                            id="Elipsa_2_kopia_6"
                            data-name="Elipsa 2 kopia 6"
                            cx={25}
                            cy="25.5"
                            rx={25}
                            ry="25.5"
                            transform="translate(2.994 2.161)"
                            fill="#0081CE"
                          />
                          <path
                            id="Icon_awesome-cart-plus"
                            data-name="Icon awesome-cart-plus"
                            d="M19.951,12.65H8.363l.259,1.265H19.233a.949.949,0,0,1,.925,1.159l-.218.96a2.214,2.214,0,1,1-2.514.411H9.138a2.214,2.214,0,1,1-2.65-.339L3.711,2.53H.949A.949.949,0,0,1,0,1.581V.949A.949.949,0,0,1,.949,0H5a.949.949,0,0,1,.929.759L6.293,2.53H21.82a.949.949,0,0,1,.925,1.159l-1.869,8.222A.949.949,0,0,1,19.951,12.65ZM16.128,6.641h-1.9V5.06a.632.632,0,0,0-.632-.632h-.632a.632.632,0,0,0-.632.632V6.641h-1.9a.632.632,0,0,0-.632.632v.632a.632.632,0,0,0,.632.632h1.9V10.12a.632.632,0,0,0,.632.632H13.6a.632.632,0,0,0,.632-.632V8.538h1.9a.632.632,0,0,0,.632-.632V7.273A.632.632,0,0,0,16.128,6.641Z"
                            transform="translate(15.994 18.661)"
                            fill="#fff"
                          />
                        </g>
                      </svg>
                    ) : (
                        <svg onClick={() => { setView("wishlist") }}
                          xmlns="http://www.w3.org/2000/svg"
                          width={56}
                          height={56}
                          viewBox="0 0 56 56"
                        >
                          <g id="Grupa_1" data-name="Grupa 1" transform="translate(0.006 -0.161)">
                            <circle
                              id="Elipsa_2_kopia"
                              data-name="Elipsa 2 kopia"
                              cx={28}
                              cy={28}
                              r={28}
                              transform="translate(-0.006 0.161)"
                              fill="#fff"
                            />
                            <ellipse
                              id="Elipsa_2_kopia_6"
                              data-name="Elipsa 2 kopia 6"
                              cx={25}
                              cy="25.5"
                              rx={25}
                              ry="25.5"
                              transform="translate(2.994 2.161)"
                              fill="#e7e7e7"
                            />
                            <path
                              id="Icon_awesome-cart-plus"
                              data-name="Icon awesome-cart-plus"
                              d="M19.951,12.65H8.363l.259,1.265H19.233a.949.949,0,0,1,.925,1.159l-.218.96a2.214,2.214,0,1,1-2.514.411H9.138a2.214,2.214,0,1,1-2.65-.339L3.711,2.53H.949A.949.949,0,0,1,0,1.581V.949A.949.949,0,0,1,.949,0H5a.949.949,0,0,1,.929.759L6.293,2.53H21.82a.949.949,0,0,1,.925,1.159l-1.869,8.222A.949.949,0,0,1,19.951,12.65ZM16.128,6.641h-1.9V5.06a.632.632,0,0,0-.632-.632h-.632a.632.632,0,0,0-.632.632V6.641h-1.9a.632.632,0,0,0-.632.632v.632a.632.632,0,0,0,.632.632h1.9V10.12a.632.632,0,0,0,.632.632H13.6a.632.632,0,0,0,.632-.632V8.538h1.9a.632.632,0,0,0,.632-.632V7.273A.632.632,0,0,0,16.128,6.641Z"
                              transform="translate(15.994 18.661)"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                      )
                  }
                </div>
                <div className="position-absolute fifth_icon_how">
                  {
                    activeView === "sidemenu" ? (
                      <svg onClick={() => { setView("sidemenu") }}
                        xmlns="http://www.w3.org/2000/svg"
                        width={56}
                        height={56}
                        viewBox="0 0 56 56"
                        style={{ boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 45px -10px", borderRadius: "100px" }}
                      >
                        <g id="Group_24031" data-name="Group 24031" transform="translate(-647 -1409)">
                          <g id="Grupa_4" data-name="Grupa 4" transform="translate(646.663 1409.394)">
                            <circle
                              id="Elipsa_2_kopia_3"
                              data-name="Elipsa 2 kopia 3"
                              cx={28}
                              cy={28}
                              r={28}
                              transform="translate(0.337 -0.394)"
                              fill="#fff"
                            />
                            <circle
                              id="Elipsa_2_kopia_9"
                              data-name="Elipsa 2 kopia 9"
                              cx="25.5"
                              cy="25.5"
                              r="25.5"
                              transform="translate(2.337 2.606)"
                              fill="#0081CE"
                            />
                          </g>
                          <g
                            id="Icon_feather-menu"
                            data-name="Icon feather-menu"
                            transform="translate(659.6 1422.588)"
                          >
                            <path
                              id="Path_3281"
                              data-name="Path 3281"
                              d="M4.5,18H27.265"
                              transform="translate(0 -2.294)"
                              fill="none"
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={3}
                            />
                            <path
                              id="Path_3282"
                              data-name="Path 3282"
                              d="M4.5,9H27.265"
                              fill="none"
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={3}
                            />
                            <path
                              id="Path_3283"
                              data-name="Path 3283"
                              d="M4.5,27H27.265"
                              transform="translate(0 -4.588)"
                              fill="none"
                              stroke="#fff"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={3}
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                        <svg onClick={() => { setView("sidemenu") }}
                          xmlns="http://www.w3.org/2000/svg"
                          width={56}
                          height={56}
                          viewBox="0 0 56 56"
                        >
                          <g id="Group_24031" data-name="Group 24031" transform="translate(-647 -1409)">
                            <g id="Grupa_4" data-name="Grupa 4" transform="translate(646.663 1409.394)">
                              <circle
                                id="Elipsa_2_kopia_3"
                                data-name="Elipsa 2 kopia 3"
                                cx={28}
                                cy={28}
                                r={28}
                                transform="translate(0.337 -0.394)"
                                fill="#fff"
                              />
                              <circle
                                id="Elipsa_2_kopia_9"
                                data-name="Elipsa 2 kopia 9"
                                cx="25.5"
                                cy="25.5"
                                r="25.5"
                                transform="translate(2.337 2.606)"
                                fill="#e7e7e7"
                              />
                            </g>
                            <g
                              id="Icon_feather-menu"
                              data-name="Icon feather-menu"
                              transform="translate(659.6 1422.588)"
                            >
                              <path
                                id="Path_3281"
                                data-name="Path 3281"
                                d="M4.5,18H27.265"
                                transform="translate(0 -2.294)"
                                fill="none"
                                stroke="#fff"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={3}
                              />
                              <path
                                id="Path_3282"
                                data-name="Path 3282"
                                d="M4.5,9H27.265"
                                fill="none"
                                stroke="#fff"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={3}
                              />
                              <path
                                id="Path_3283"
                                data-name="Path 3283"
                                d="M4.5,27H27.265"
                                transform="translate(0 -4.588)"
                                fill="none"
                                stroke="#fff"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={3}
                              />
                            </g>
                          </g>
                        </svg>
                      )
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xl-6">
            <div className="align-items-center d-flex h-100 max_700">
              <div>
                {
                  activeView === "calender" && (
                    <>
                      <h1 className="center_align_text" style={{ fontSize: "30px", fontWeight: "600" }}>Upload your <span style={{ color: "#2091D5", fontWeight: "600" }}>Prescription!</span></h1>
                      <p className="child_p mb-0 center_align_text">
                        Upload your prescription and let our experienced<br></br> pharmacists handle the rest.

                   </p>
                    </>
                  )
                }
                {
                  activeView === "notification" && (
                    <>
                      <h1 className="center_align_text" style={{ fontSize: "30px", fontWeight: "600" }}>Sign Up with <span style={{ color: "#2091D5", fontWeight: "600" }}>Dawa Asaan</span></h1>
                      <p className="child_p mb-0 center_align_text">
                        Download our application and become a part of Pakistan’s<br></br> first smart pharmacy.
                   </p>
                    </>
                  )
                }
                {
                  activeView === "network" && (
                    <>
                      <h1 className="center_align_text" style={{ fontSize: "30px", fontWeight: "600" }}>Switch to a <span style={{ color: "#2091D5", fontWeight: "600" }}>simpler pharmacy today!</span></h1>
                      <p className="child_p mb-0 center_align_text">
                        Easy access to all your smart pharmaceutical needs.
                   </p>
                    </>
                  )
                }
                {
                  activeView === "wishlist" && (
                    <>
                      <h1 className="center_align_text" style={{ fontSize: "30px", fontWeight: "600" }}>We are all about <span style={{ color: "#2091D5", fontWeight: "600" }}>convenience!</span></h1>
                      <p className="child_p mb-0 center_align_text">
                        Our representative will send you your digital<br></br> prescription as to your preferred time slots. Confirm<br></br> your order and become a part of our smart journey.
                   </p>
                    </>
                  )
                }
                {
                  activeView === "sidemenu" && (
                    <>
                      <h1 className="center_align_text" style={{ fontSize: "30px", fontWeight: "600" }}>Never <span style={{ color: "#2091D5", fontWeight: "600" }}>miss a Dose!</span></h1>
                      <p className="child_p mb-0 center_align_text">
                        Notifications will remind you of when it is time to take <br></br>your med's and when it's time to reorder.
                   </p>
                    </>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid hero_bg">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <img className="ml-auto mr-auto d-block" src={require("../../assets/images/dawaasaan.svg")}></img>
            <h1 style={{ fontSize: "30px", fontWeight: "500" }} className="text-center text-white mt-4">Our service is free, you only pay<br></br> for your medicines</h1>
            <a href="/contact"><button className="action_button_dawa btn btn-lg d-block ml-auto mr-auto mt-4 scrollTop mb-3" type="button"
            //  onClick={scrollTop}
            >
              Get Started
            </button></a>
            <div className="d-flex justify-content-center">
              <a className="mr-2" href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507" target="blank"><img className="img-fluid" src={require("../../assets/images/ios.png")}></img></a>
              <a href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan" target="blank"><img className="img-fluid" src={require("../../assets/images/google.png")}></img></a>
            </div>
          </div>
        </div>
      </div>
      <section className="pp-section pp-section--overview pb-0 pt-0">
        <div className="align_items_enter d-flex justify-content-end section-inner overview_text_height">
          <div className="pp-txt-mod--secondary">
            {/* <p className="section-subh">Customer support</p> */}
            <h3 className="section-h" style={{ color: "#5A5A5A", fontSize: "2.5rem" }}>Your <span style={{ color: "#008CD3", fontWeight: "600" }}>Questions</span> Answered</h3>
            <p className="section-p large">
              Our Customer services agents are happy to help in any way they can to make this journey easy for you. Our aim is to make the process of taking your medications simpler.</p>
          </div>
        </div>
      </section>
      <div className="container-fluid hero_bg_plan">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h1 style={{ fontSize: "42px", fontWeight: "500", color: "#26272D" }} className="mt-4">Your Medication<br></br><span style={{ color: "#008CD3", fontWeight: "600" }}>Simplified</span></h1>
              <p style={{ textTransform: "uppercase", color: "#26272D", fontWeight: "800", fontSize: "10px" }} className="mb-2 mt-4">You are</p>
              <ul className="ul_listing">
                <li className={`${patientType === "patient" ? 'taker_class' : 'taker_class_2'}`} onClick={() => { checkPlan("patient") }}>Patient</li>
                <li className={`${patientType === "caretaker" ? 'taker_class' : 'taker_class_2'}`} onClick={() => { checkPlan("caretaker") }}>Caretaker</li>
              </ul>
              {
                patientType === "patient" ?
                  (
                    <React.Fragment>
                      <p className="mt-4 mb-0 text_resize" style={{ color: "#8C8F94"}}>We aim to make your life easier by<br></br> taking responsibility of delivering your<br></br> pre-sorted medication. <br></br>If you are a patient with daily medication,<br></br> Dawa Asaan is just for you! Choose to try us<br></br> as one-time or recurring user.</p>
                      <p style={{ fontSize: "13px" }}>Wants to know more? <Link target="blank" className="text_underline_text" to="/contact">Let‘s talk</Link></p>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <p className="mt-4 mb-0 text_resize" style={{ color: "#8C8F94"}}>We aim to make your life easier by<br></br> taking responsibility of delivering<br></br> pre-sorted medications for your loved one.<br></br> If you are a carer for a patient with daily<br></br> medication, Dawa Asaan is just for you!<br></br> Choose to try us as a one-time or recurring<br></br> user</p>
                      <p style={{ fontSize: "13px" }}>Wants to know more? <Link target="blank" className="text_underline_text" to="/contact">Let‘s talk</Link></p>
                    </React.Fragment>
                  )
              }
            </div>
            <div className="col-md-6">
              <div className="flex_property">
                <div className={`pricing_width ${planTime === "one" ? 'time_checking' : 'time_checking_2'}`} onClick={() => { checkTime("one") }}>
                  <div
                    className="pricing-item pricing_table_design">
                    {/* Indicator of subscription type */}
                    <div className="pt-4 pb-3" style={{ letterSpacing: 2 }}>
                      <h4 className="text-center">Single Order</h4>
                    </div>
                    {/* Price class */}
                    <div className="pricing-price pb-1 text-primary color-primary-text ">
                      <p className="text-center" style={{ color: "#8C8F94", fontSize: "20px" }}>Upload your prescriptions<br></br> and<br></br> begin your journey!<br></br><br></br><br></br> We will deliver your <br></br>pre-sorted medicines to <br></br>your doorstep within<br></br> 24 hrs!</p>
                    </div>
                    {/* Button */}
                    <div className="pricing-button pb-4">
                      <Link target="blank" to="/contact"><button type="button" className="btn btn-lg d-block btn_pricing ml-auto mr-auto w-75" style={{ background: "#267DF4" }}>
                        Get started
                       </button></Link>
                    </div>
                  </div>
                </div>
                <div className={`pricing_width ${planTime === "two" ? 'time_checking' : 'time_checking_2'}`} onClick={() => { checkTime("two") }}>
                  <div
                    className="pricing-item pricing_table_design">
                    {/* Indicator of subscription type */}
                    <div className="pt-4 pb-3" style={{ letterSpacing: 2 }}>
                      <h4 className="text-center">Subscribe to our services</h4>
                    </div>
                    {/* Price class */}
                    <div className="pricing-price pb-1 text-primary color-primary-text ">
                      <p className="text-center" style={{ color: "#8C8F94", fontSize: "20px" }}>You never have to worry<br></br> about your monthly medications again!<br></br><br></br> Send us your Prescription,<br></br> and<br></br> we will always deliver your medicines at the right time, before you run out of your monthly meds.</p>
                    </div>
                    {/* Button */}
                    <div className="pricing-button pb-4">
                      <Link target="blank" to="/contact"><button type="button" className="btn btn-lg btn_pricing d-block ml-auto mr-auto w-75" style={{ background: "#267DF4" }}>
                        Get started
                       </button></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container_setting hero_last_section">
        <div className="row">
          <div className="col-12 col-lg-6 col-xl-6">
            <div className="align-items-center d-flex h-100">
              <div>
                <h1 style={{ fontSize: "30px", fontWeight: "600" }}><span style={{ color: "#2091D5", fontWeight: "600" }}>Safety</span> is our priority</h1>
                <p className="child_p">
                  Your safety is our utmost priority. At the core of our<br></br> service, we care for our patients health. Our<br></br> experienced professionals and regularly sterilized<br></br>  environment would never pose any risk to your health.
                </p>
                <Link to="/contact" target="blank">
                  <button type="button" className="btn btn-lg d-block btn_pricing_case" style={{ fontSize: "15px" }}>
                    Get Started <img className="pl-2" src={require("../../assets/images/angel.png")}></img>
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 phone-holder">
            <div className="iphone-mockup_left">
              <img style={{ width: "100%" }} src={require("../../assets/images/box3-1.png")}></img>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  )
}
export default HowItWorks;